/**
 * Country type.
 */
export class Country {
  codeA2: string;
  codeA3: string;
  phoneCodes: PhoneCode[];
  en: string;
  localized: string;
  isEnabled: boolean;
  region: string;
  disclaimerRequired: boolean;

  /** Поиск страны по 3х-значному коду.
   * @param {Country[]} countries Список стран
   * @param {string} code Код нужной страны
   * @returns {Country} Найденная страна
   */
  static byCode3(countries: Country[], code: string): Country {
    let country = new Country();
    if (countries) {
      country = countries.find(c => c.codeA3 === code);
    }
    return country ? country : new Country();
  }
}

export class PhoneCode {
  countryId: number;
  phoneCode: number;
  isDefault: boolean;
}
